import React, { useState } from 'react';
import { ColorPicker } from './ColorPicker';

interface ModelColorButtonProps {
  modelId: string;
  currentColor: string;
  onColorChange: (modelId: string, color: string) => void;
  disabled?: boolean;
}

export function ModelColorButton({
  modelId,
  currentColor,
  onColorChange,
  disabled = false,
}: ModelColorButtonProps) {
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const handleColorChange = (color: string) => {
    onColorChange(modelId, color);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!disabled) {
      setIsPickerOpen(!isPickerOpen);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleButtonClick}
        disabled={disabled}
        data-color-button
        className={`
          w-4 h-4 rounded-sm border-2 border-white dark:border-gray-800 shadow-sm transition-all duration-200
          ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:scale-110 hover:shadow-md'}
        `}
        style={{ backgroundColor: currentColor }}
        title={`Change color for ${modelId}`}
      />

      <ColorPicker
        currentColor={currentColor}
        onColorChange={handleColorChange}
        onClose={() => setIsPickerOpen(false)}
        isOpen={isPickerOpen}
      />
    </div>
  );
}
